import styles from './DownloadCompleted.module.scss'
import BottomSlider from 'components/commons/BottomSlider/BottomSlider'
import Column from 'components/home/Column'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

const DownloadCompleted: React.FC = () => {
  return (
    <article className={styles.main}>
      <script>fbq('track', 'Lead');</script>
      <section className={styles.content}>
        <div className={styles.inner}>
          <div className={styles.title_group}>
            <div className={styles.text_container}>
              <h1 className={styles.title}>ご入力いただきありがとうございます</h1>
              <p className={styles.firsttext}>
                ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。
                <br />
                メールをご確認いただき、資料をダウンロードしてください。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.section}>
        <BottomSlider />
      </section>
      <Column tagType="h2" />
      <MailmagazineLink noGsap />
    </article>
  )
}

export default DownloadCompleted
